import { BaseService } from "../../core/baseService";
import {
  ChatAttachmentServiceInterface,
  ChatAttachmentUploadResult,
  ChatAttachmentSasResult,
} from "../types/chatAttachment.types";
import { ApiResult } from "../../core/types";

export class ChatAttachmentService
  extends BaseService
  implements ChatAttachmentServiceInterface
{
  async uploadAttachment(
    file: File
  ): Promise<ApiResult<ChatAttachmentUploadResult>> {
    const formData = new FormData();
    formData.append("file", file);

    return this.handleRequest<ChatAttachmentUploadResult>(
      this.client.post("/api/admin/chat/attachment", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    );
  }

  async getAttachmentSasUrl(
    messageId: string
  ): Promise<ApiResult<ChatAttachmentSasResult>> {
    return this.handleRequest<ChatAttachmentSasResult>(
      this.client.get(`/api/admin/chat/attachment-sas/${messageId}`)
    );
  }
}
